import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './Modal.css';

class ModalHeader extends React.Component {
  render() {
    return (
      <Modal.Header>
        <Modal.Title bsClass={`modal-title ${styles['modal-title']}`}>
          {this.props.title}
        </Modal.Title>
      </Modal.Header>
    );
  }
}

ModalHeader.propTypes = {
  title: PropTypes.string,
};

export default ModalHeader;
